import { Sky } from '@react-three/drei';

interface SkyEnvironmentProps {
  turbidity?: number;
  rayleigh?: number;
  mieCoefficient?: number;
  mieDirectionalG?: number;
  sunPosition?: [number, number, number];
}

/**
 * Sky component with bright daytime atmosphere
 * Creates aviation-friendly clear blue sky
 */
export function SkyEnvironment({
  turbidity = 6,
  rayleigh = 0.5,
  mieCoefficient = 0.005,
  mieDirectionalG = 0.8,
  sunPosition = [100, 50, 100],
}: SkyEnvironmentProps): React.JSX.Element {
  return (
    <Sky
      distance={450000}
      sunPosition={sunPosition}
      turbidity={turbidity}
      rayleigh={rayleigh}
      mieCoefficient={mieCoefficient}
      mieDirectionalG={mieDirectionalG}
      inclination={0.6}
      azimuth={0.25}
    />
  );
}
